import React, { useState } from "react";
import "./style.css";
import { CloseCircleFilled } from "@ant-design/icons";

export default function AlertError({ reject_reason, register_state, isClosed, setIsClosed }) {
  return (
    <div className="alert-error-container" style={{ display: isClosed ? "none" : "block", border: (register_state === 1) | (register_state === 0) && "2px solid #FFFF00" }}>
      <div className="alert-error-content" style={{ backgroundColor: (register_state === 1) | (register_state === 0) && "#FFFF0050" }}>
        <div style={{ position: "absolute", right: 10, top: 5, fontSize: 20, cursor: "pointer" }} onClick={() => setIsClosed(true)}>
          <CloseCircleFilled />
        </div>
        <div style={{ fontSize: 18, fontWeight: "bold" }}>แจ้งเตือน</div>
        {register_state === 1 ? (
          <div>เรากำลังตรวจสอบข้อมูลของคุณ หากพบปัญหากรุณาติดต่อ เจ้าหน้าที่.</div>
        ) : register_state === 0 ? (
          <div>เพื่อให้สามารถรับงานจากนักกอล์ฟได้กรุณากรอก `ข้อมูลที่จำเป็น` ให้ครบเพื่อยืนยันบัญชีของคุณ</div>
        ) : (
          <div>ระบบไม่อนุมัติข้อมูลเนื่องจาก : {reject_reason}</div>
        )}
      </div>
    </div>
  );
}
